import { unifiedApi } from "@/common";
import { IUnauthenticatedSubscription } from "@/common/api/unifiedPortal/interfaces";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useUnauthenticatedBuyFlowStore = defineStore("unauthenticatedBuyFlow", () => {
  const subscription = ref<IUnauthenticatedSubscription>();

  async function populateSubscription(deviceId: number) {
    try {
      subscription.value = (await unifiedApi.getSubscriptionForUnauthorizedFlow(deviceId)).data;
    } catch (err) {
      // leave decision how to handle error to the caller
      throw err;
    }
  }

  return {
    subscription,
    populateSubscription,
  };
});
